import store from "../../index";
import MenuElement from "./MenuElement";

export default class MenuEditorList {
  constructor(data) {
    if (data && !(data instanceof Array)) {
      throw new Error(
        "Only array data allowed to create the MenuEditingList class"
      );
    }
    this.data = (data || []).map(v => new MenuElement(v));
    this.parent_uuid = null;
  }

  get count() {
    return this.data.length;
  }

  static async selfInitFromLoadedData(res = undefined) {
    res ||
      (res = (await store.dispatch("cache/shared_menu/loadData")).data
        .opupet_query);
    let data = new Map(
      res
        .sort((a, b) => a.sort - b.sort)
        .map(v => [v.uuid, Object.assign({}, v)])
    );
    for (let v of data.values()) {
      v.children || (v.children = []);
      if (!v.parent_uuid) {
        continue;
      }
      let p = data.get(v.parent_uuid);
      (p.children || (p.children = [])).push(v);
    }
    for (let v of data.values()) {
      if (!v.parent_uuid) {
        continue;
      }
      data.delete(v.uuid);
    }
    return new this([...data.values()]);
  }

  getRawData() {
    let raw = [];
    this.data.forEach((v, i) => {
      v.sort = i + 1;
      v.parent_uuid = this.parent_uuid;
      raw = raw.concat(v.getRawData());
    });
    return raw;
  }

  addNewChildren() {
    this.data.push(new MenuElement({ disabled: true }));
  }
}
